module.exports = __webpack_public_path__ + "static/media/mcacom.76d08475.jpg";